var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49854 18.6667L8.71315 13.4521C9.1093 13.056 9.64661 12.8334 10.2069 12.8334C10.7671 12.8334 11.3044 13.056 11.7006 13.4521L16.3319 18.0834M16.3319 18.0834L18.0819 19.8334M16.3319 18.0834L18.6299 15.7854C19.0259 15.3893 19.5633 15.1667 20.1235 15.1667C20.6838 15.1667 21.2211 15.3893 21.6172 15.7854L24.4985 18.6667",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0819 9.32693C18.404 9.32693 18.6652 9.06576 18.6652 8.7436C18.6652 8.42143 18.404 8.16026 18.0819 8.16026M18.0819 9.32693C17.7598 9.32693 17.4985 9.06576 17.4985 8.7436C17.4985 8.42143 17.7598 8.16026 18.0819 8.16026M18.0819 9.32693V8.16026",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31291 23.032C2.91528 21.3956 2.91528 18.9282 2.91528 13.9936C2.91528 9.05891 2.91528 6.59156 4.31291 4.95515C4.51138 4.72277 4.72779 4.50636 4.96017 4.30789C6.59658 2.91026 9.06393 2.91026 13.9986 2.91026C18.9333 2.91026 21.4007 2.91026 23.037 4.30789C23.2694 4.50636 23.4858 4.72277 23.6843 4.95515C25.082 6.59156 25.082 9.05891 25.082 13.9936C25.082 18.9282 25.082 21.3956 23.6843 23.032C23.4858 23.2644 23.2694 23.4808 23.037 23.6793C21.4007 25.0769 18.9333 25.0769 13.9986 25.0769C9.06393 25.0769 6.59658 25.0769 4.96017 23.6793C4.72779 23.4808 4.51138 23.2644 4.31291 23.032Z",
    stroke: "#050505",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalScreenshot);
export default __webpack_public_path__ + "static/media/Total_Screenshot.b7acdc0193315e3e766c34d6a95926b5.svg";
export { ForwardRef as ReactComponent };